import React, { useState } from "react";
import { men } from "../../data/user-dashboard";
import { BlackButton } from "../Buttons";
import { FaShoppingBag } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { removeFromWishlist } from "../../redux/store/wishlist";
import { addToCart } from "../../redux/store/cartSlice";
import { Helmet } from "react-helmet-async";
import api from "../../utilis/api";
import { toast } from "react-toastify";

const Wishlist = () => {
  const wishlistItems = useSelector((state) => state.wishlist.wishlistItems);
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.user);
  const [comments, setComments] = useState({});
  const handleSubmit = async (product) => {
    try {
      console.log(product.id, product);
      const commentText = comments[product.id];
      if (!commentText) return;
      const payload = {
        comment: commentText,
        productItems: {
          productId: product.id,
          name: product.title,
          price: product?.variants?.[0].price,
          image: product.image,
        },
      };
      const response = await api.post("/coments/create", payload, {
        headers: { authorization: `Bearer ${token}` },
      });
      console.log(response);
      if (response.data) {
        toast.success("Comment Added Successfully", { autoClose: 3000 });
        setComments({ ...comments, [product.id]: "" });
      } else {
        toast.error(response.data?.meta?.message || "Coment failed", {
          autoClose: 4000,
        });
      }
    } catch (error) {
      console.log(error);
      const message =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Something went wrong";
      toast.error(message, { autoClose: 5000 });
    }
  };

  const handleAddCart = (product) => {
    dispatch(addToCart(product));
  };
  const handleRemove = (id) => {
    dispatch(removeFromWishlist(id));
  };

  return (
    <>
      <Helmet>
        <title>My Wish List</title>
        <meta name="description" content={`Welcome to My Wish List page`} />
      </Helmet>

      <div className="w-full px-[0.5rem] sm:px-[2rem]">
        <h1 className="text-center font-bold text-[1.6rem] sm:text-[1.7rem] md:text-[1.8rem]">
          My Wish List
        </h1>
        <div className="mt-[1rem] py-[1rem] px-[0.5rem] flex justify-between items-center">
          <span className="text-gray-500">{wishlistItems.length} Item(s)</span>
          <div className="flex gap-[0.5rem] items-center">
            <label htmlFor="page">Show</label>
            <select className="p-1 rounded-md border focus:none text-gray-500">
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </div>
        </div>

        <div className="w-full flex flex-wrap gap-6 justify-start">
          {wishlistItems && wishlistItems.length > 0 ? (
            wishlistItems.map((product) => (
              <div className="w-[100%] md:w-[300px] h-[100%] md:h-[450px] p-[1rem] shadow-[0_3px_8px_rgba(0,0,0,0.24)] group overflow-hidden flex flex-col">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-[200px] object-contain transition-transform duration-300 ease-in-out group-hover:scale-110"
                />

                {/* Content */}
                <div className="flex-1 flex flex-col justify-between mt-[1rem]">
                  <div>
                    <h1 className="font-semibold text-[1.2rem]">
                      {product.title}
                    </h1>

                    <label>Comment</label>
                    <textarea
                      rows={3}
                      value={comments[product.id] || ""}
                      onChange={(e) =>
                        setComments({
                          ...comments,
                          [product.id]: e.target.value,
                        })
                      }
                      className="border rounded-md border-gray-500 px-1 text-gray-500 w-full"
                    />
                  </div>

                  {/* Buttons */}
                  <div className="flex items-center justify-between mt-2">
                    <button
                      onClick={() => handleSubmit(product)}
                      className="bg-black text-white px-8 py-2 rounded-lg hover:bg-gray-800 transition-all duration-300"
                    >
                      Comment
                    </button>
                    <div className="flex items-center gap-[0.5rem]">
                      <button
                        onClick={() => handleAddCart(product)}
                        className="w-[2rem] h-[2rem] rounded-full bg-green-200 flex items-center justify-center transition-all duration-300 ease-in-out hover:bg-green-300 hover:scale-110"
                      >
                        <FaShoppingBag color="green" size={18} />
                      </button>

                      <button
                        onClick={() => handleRemove(product.id)}
                        className="w-[2rem] h-[2rem] rounded-full bg-red-200 flex items-center justify-center transition-all duration-300 ease-in-out hover:bg-red-300 hover:scale-110"
                      >
                        <MdDelete color="red" size={18} />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="mt-[2rem]">
              <p className="w-full text-center text-blue-800 bg-blue-100 border border-blue-400 rounded-md py-3 px-4 text-sm font-medium shadow-md">
                No products found.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Wishlist;
